// extracted by mini-css-extract-plugin
export default {"Box":"MultiSelectionFromCategorizedStringArray_Box__z61op"};